/**
 * @description Mask for normalize cellphone - locale pt_br;
 */
export const normalizeCellphone = (value) => {
  if (!value) return '';
  return value
    .replace(/[\D]/g, '')
    .replace(/(\d{2})(\d)/, '($1) $2')
    .replace(/(\d{5})(\d)/, '$1-$2')
    .replace(/(-\d{4})(\d+?)/, '$1');
};

/**
 * @description Mask for normalize CPF -  locale pt_br;
 */
export const normalizeCPF = (value) => {
  if (!value) return '';

  return `${value}`
    .replace(/[\D]/g, '')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(.\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1-$2')
    .replace(/(-\d{2})(\d+?)/, '$1');
};

export const normalizeCNPJ = (value) => {
  if (!value) return '';

  return `${value}`
    .replace(/[\D]/g, '')
    .replace(/(\d{2})(\d)/, '$1.$2')
    .replace(/(.\d{3})(\d)/, '$1.$2')
    .replace(/(.\d{3})(\d)/, '$1/$2')
    .replace(/(\/\d{4})(\d)/, '$1-$2')
    .replace(/(-\d{2})(\d+?)/, '$1');
};

/**
 * @description Mask for normalize CEP -  locale pt_br;
 */
export const normalizeCEP = (value) => {
  if (!value) return '';
  return value
    .replace(/[\D]/g, '')
    .replace(/(\d{5})(\d)/, '$1-$2')
    .replace(/(\d{5})(\d)/, '$1-$2')
    .replace(/(-\d{3})(\d+?)/, '$1');
};

/**
 * @description Mask for money -  locale pt_br;
 */
export const moneyMask = (value) => {
  if (!value) return '';
  const maskedValue = value
    .replace(/\D/g, '')
    .replace(/(\d{1,})(\d{2})$/, '$1,$2')
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');

  return `R$ ${maskedValue}`;
};


export const maskCpfOrCnpj = (value) => {
  if (value === null || value === undefined) return "";

  const digits = String(value).replace(/\D/g, "");

  // CPF: 11 dígitos ou menos
  if (digits.length <= 11) {
    return digits
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})\.(\d{3})(\d)/, "$1.$2.$3")
      .replace(/(\d{3})\.(\d{3})\.(\d{3})(\d)/, "$1.$2.$3-$4")
      .replace(/(-\d{2})(\d+?)$/, "$1");
  }

  // CNPJ: 12 dígitos ou mais (vai “montando” até 14)
  return digits
    .replace(/(\d{2})(\d)/, "$1.$2")
    .replace(/(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
    .replace(/(\d{2})\.(\d{3})\.(\d{3})(\d)/, "$1.$2.$3/$4")
    .replace(/\/(\d{4})(\d)/, "/$1-$2")
    .replace(/(-\d{2})(\d+?)$/, "$1");
};

